import { Header } from "@/components/Header";
import { PageText } from "@/components/PageText";

export function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="mx-auto max-w-[720px] px-6 py-16">
        <PageText id="about" titleClassName="font-serif text-[38px] font-semibold tracking-[-0.015em]" bodyClassName="mt-6 font-serif text-lg leading-relaxed" />
      </main>
    </div>
  );
}
